export default __webpack_public_path__ + "static/media/Ligne+point.9ccf513f.svg";